// extracted by mini-css-extract-plugin
export default {"root":"Message_root__HLMpC","title":"Message_title__6T51z","text":"Message_text__v6uis"};